import React from 'react'
import './Footer.css'
const Footer = () => {
    return (
        <footer>
            <div className="footContainer">
                <p className="color">Copyright &copy; 2025 FileDrop.com</p>
            </div>
        </footer>
    )
}

export default Footer
